module.exports = __webpack_public_path__ + "static/day02-41886eb01182967fe06a040d43501948.png";